import Vue from 'vue'
import VueRouter from 'vue-router'
import versionTood from '@/libs/versionUpdate'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('../views/index.vue')
  },
  {
    path: '/login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/course',
    component: () => import('../views/course.vue')
  },
  {
    path: '/course/:ID(\\d+)',
    component: () => import('../views/course.vue')
  },
  {
    path: '/memberCentre',
    component: () => import('../views/memberCentre.vue')
  },
  {
    path: '/showHtml/:ID(\\d+)',
    component: () => import('../views/showHtml.vue')
  },
  {
    path: '/showVod/:ID',
    component: () => import('../views/showVod.vue')
  },
  {
    path: '/kong',
    component: () => import('../views/kong.vue')
  },
  {
    path: '/news/:ID(\\d+)',
    component: () => import('../views/news.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  //判断当前代码版本是否与服务器中代码版本一致，如不一致则刷新页面获取最新
  versionTood.isNewVersion();
  
  // var ua = navigator.userAgent.toLowerCase()
  // console.log(ua)
  // if(ua.match(/MicroMessenger/i)=="micromessenger") {
  //   if(to.path === '/kong'){
  //     next()
  //   }else{
  //     next('/kong')
  //   }
  // } else if (ua.match(/QQ/i) == "qq") {
  //   console.log('qq')
  //   if(to.path === '/kong'){
  //     next()
  //   }else{
  //     next('/kong')
  //   }
  // }else {
  //   next()
  // }
  next()
})


export default router
